export default function getResource(label, vars = []) {
    const resources = {
        manageSubscription: 'Manage Subscription',
        qty: 'Qty',
        notRated: 'Not rated',
        oneReview: '1 review',
        deliveryEvery: 'Delivery Every',
        deliveryTitle: 'Delivery Frequency',
        deliveryValue: `Every ${vars[0]}`,
        creditCardExpDate: 'Exp',
        shippingAddress: 'Shipping Address',
        paymentMethod: 'Payment Method',
        deliveryFrequency: 'Delivery Frequency',
        item: `ITEM ${vars[0]}`,
        chooseDeliveryFreq: 'Choose Delivery Frequency:',
        every: 'Every',
        mostCommon: 'Most Common',
        youWillSave: 'you will save',
        annualyWithSubs: 'annually with this subscription.',
        cancel: 'Cancel',
        frequencyNumber: 'Frequency Number',
        frequencyType: 'Frequency Type',
        skip: 'Skip',
        pause: 'Pause',
        autoReplenishSummary: 'Auto-Replenish Summary',
        active: 'Active',
        paused: 'Paused',
        viewShipments: 'View Shipments',
        biPointsEarned: 'Beauty Insider Points earned from Auto-Replenish',
        totalSaving: 'Total Auto-Replenish Savings',
        points: 'points',
        askToUpdateDelivery: 'Want it sooner? Update your delivery frequency.',
        cvvSubmitButtonText: 'Confirm',
        legalCopy: 'Your card will be charged automatically based on the frequency of your shipments.',
        cancelSubscription: 'Cancel Subscription',
        changeDate: 'Change Date',
        nextShipment: 'Next Shipment:',
        skuSwapButton: 'Swap Item',
        skuSwapUnavailable: 'No other options for this item',
        selectAddress: 'Select your Address',
        selectPayment: 'Select your Payment',
        annuallySaving: `${vars[0]}, you will save <b>${vars[1]}</b> annually with this subscription.`,
        hotDealSaving: `${vars[0]}, you can still save <b>${vars[1]}</b> before ${vars[2]}.`,
        resumeModalTitle: 'Resume Subscription',
        resumeSubmitButtonText: 'Resume',
        resumeSuccessButtonText: 'Resumed'
    };

    return resources[label];
}
